<template>
  <v-card flat :color="cardColor" class="ma-0 pa-0" v-if="showDetail">
    <v-card-title v-if="cardTitle">{{ cardTitle }}</v-card-title>
    <v-img v-if="strip" :src="strip" :max-height="35"></v-img>
    <v-toolbar :color="toolbarColor" dense short v-if="!hideToolbar">
      <v-toolbar-title>
        <v-text-field v-if="!compressed" v-model="search" append-icon="search" :label="`Search ${rowHeading}`" single-line
          hide-details clearable></v-text-field>
        <span v-else class="subtitle-2 pa-0 ma-0">{{ rowHeading }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <hide-detail v-if="hideable" prop-name="hideContent" :tooltip="rowHeading" left :hide="hideContent"
        @hide="hide"></hide-detail>
    </v-toolbar>
    <div v-else>
      <span class="subtitle-2 pa-0 ma-0">{{ rowHeading }}</span>
    </div>
    <v-card-text v-if="!hideContent">
      <v-data-table v-if="items && items.length" :items="items" hide-default-footer hide-default-header
        :no-data-text="noDataText" :search="search" :headers="headers" :custom-filter="filterer"
        :items-per-page="items.length">
        <template v-slot:item="{ item }">
          <item-row-detail v-if="compressed" :item-type="itemType" :item="item" compressed image-column
            :row-type="rowType" :hideIconColumn="hideIconColumn" :rowColor="cardColor" :score="score"
            :merge-button="mergeButton" @merge="emitMerge" :player-instance="playerInstance"
            :merge-into="mergeInto"></item-row-detail>
          <item-row-detail v-else :item-type="itemType" :item="item" brief image-column :row-type="rowType"
            :avatar="useAvatar" :all-prizes="allPrizes" :rowColor="cardColor" :score="score" :merge-button="mergeButton"
            @merge="emitMerge" :player-instance="playerInstance" :merge-into="mergeInto"></item-row-detail>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import Itemrowdetail from '@/components/Itemrowdetail'
import { SearchUtils } from '@/js'
import Hidedetail from '@/components/Hidedetail'
export default {
  props: {
    strip: String,
    mergeInto: Object,
    mergeButton: Boolean,
    cardTitle: String,
    score: Boolean,
    items: Array,
    compressed: Boolean,
    allPrizes: Array,
    hideIconColumn: Boolean,
    cardColor: String,
    hideToolbar: {
      type: Boolean,
      default: false
    },
    toolbarColor: {
      default: 'secondary lighten-1',
      type: String
    },
    hideable: {
      Boolean,
      default: true
    },
    rowType: {
      type: String,
      required: true
    },
    itemType: {
      type: String,
      required: true
    },
    playerInstance: String
  },
  methods: {
    emitMerge(pack) {
      this.$emit('merge', pack)
    },
    hide(pack) {
      this[pack.propName] = pack.hide
    },
    filterer(value, search, item) {

      // we're searching all the searchable text in this item
      let rx = ''
      try {
        rx = new RegExp(search, 'img')
      } catch (err) {
        rx = search
      }
      // find the index of this item
      const index = this.items.findIndex(f => f.itemID === item.itemID)
      if (index === -1) {
        console.log('failed to find item for filtering', item);
        return false;
      }

      return this.searchableText.headings[index].match(rx) ||
        this.searchableText.stories[index].some(h => h.some(j => j.text.match(rx)))
    },

    years() {
      // get all the known years -- not used yet may add later or scrap
      return (this.items || [])
        .reduce((p, c) => {
          c.MatchReasons.forEach(g => (g.AwardPrizeMatchItems || []).forEach(h => p.push(h.theYear)))
          return p
        }, []).filter((f, i, a) => a.indexOf(f) === i).sort()
    },
    prizes() {
      // get a list of known prizes, sort and dedupped -- not used yet may add later or scrap
      return (this.items || [])
        .reduce((p, c) => {
          c.MatchReasons.forEach(g => (g.AwardPrizeMatchItems || []).forEach(h => h.AwardPrize
            ? p.push({
              name: h.AwardPrize.AwardPrizeLocalized.name,
              id: h.AwardPrize.AwardPrizeLocalized.id,
              itemOrder: h.AwardPrize.itemOrder
            })
            : null
          ))
          return p
        }, []).filter((f, i, a) => a.findIndex(g => g.id === f.id) === i).sort((a, b) => a.itemOrder - b.itemOrder)
    }
  },
  data: () => ({
    search: '',
    defaultHeaders: [{ value: 'icon', text: 'icon' }, { value: 'text', text: 'text' }],
    hideContent: false
  }),
  computed: {
    headers() {
      const h = this.hideIconColumn ? this.defaultHeaders.slice(1) : this.defaultHeaders
      if (this.mergeButton) h.push({
        value: 'merge',
        text: 'merge'
      })
      if (this.score) h.push({
        value: 'score',
        text: 'score'
      })
      return h;
    },
    showDetail() {
      // if it's compressed then there is only 1 item
      // if not compressed then there's an item for every reason
      return this.items && this.items.length && (!this.compressed || (this.items[0] && this.items[0].MatchReasons && this.items[0].MatchReasons.length))
    },
    searchableText() {
      // if there's searching going on we need to digest the items to make them searchable
      if (!this.items) return null
      const storyType = this.itemType === 'award' ? 'award' : this.rowType
      const stories = this.items.map(f => f.MatchReasons.map(g => SearchUtils.getStoryFromReason({ reason: g, rowType: storyType, allPrizes: this.allPrizes })))
      const headings = this.items.map(f => SearchUtils.getBigTextFromReason({ reason: f.itemReason }))
      return {
        headings,
        stories
      }
    },
    useAvatar() {
      return this.compressed
    },
    rowHeading() {
      return SearchUtils.unCamel({ pluralize: true, text: this.rowType })
    },
    noDataText() {
      return `no info for ${this.rowHeading}`
    }
  },
  components: {
    'item-row-detail': Itemrowdetail,
    'hide-detail': Hidedetail
  },
  name: 'Contentdetail'
}
</script>
